/**  订单属性配置   目前未做价格 适配  后期需要做价格适配 ，资源配置交由后台获取**/


const store = {
  recharge:{
    QB:'Q币充值',
    VIRTUAL:'虚拟币充值',
  },
  transaction:{
    options: [
      { label: "充值", value: 'RECHARGE' },
      { label: "回收", value: 'REFUND' },
      { label: "返利", value: 'REBATE' },
      { label: "购买订单", value: 'BUY' },
      { label: "续签订单", value: 'RENEW' },
    ],
    map: {
      'RECHARGE': "充值",
      'REFUND': "回收",
      'REBATE': "返利",
      'BUY': "购买订单",
      'RENEW': '续签订单'
    }
  }
};


export default store;



// WEBPACK FOOTER //
// ./src/api/lang/modules/store/store_zh.js